import { BasicSVG } from "../basicsvg.js";
/**
 * @class MSRect
 * @extends BasicSVG
 * @classdesc �������������
 * */
export class MSRect extends BasicSVG {
    constructor() {
        super();
        this._createInnerSVG('rect');
        this.borderthickness = 2;
        this.backgroundcolor = 'TRANSPARENT'
    }

    set width(value) {
        this._width = value;
        const tmp = Number(value);
        if (tmp) {
            this.style.width = this._setValueUnit(value);
            this._path.setAttribute('width', tmp);
            this._resource && (this.resource = this._resource);
        }
    }

    set height(value) {
        this._height = value;
        const tmp = Number(value);
        if (tmp) {
            this.style.height = this._setValueUnit(value);
            this._path.setAttribute('height', tmp);
            this._resource && (this.resource = this._resource);
        }
    }
}